import { decamelizeKeys } from 'humps';

const isCityPlace = place =>
  place?.result_type === 'city' || place?.resultType === 'city';

export const isHybridRecentSearch = ({ origin, destination } = {}) =>
  Boolean(origin && destination) && isCityPlace(origin) !== isCityPlace(destination);

export const isCityToCityRecentSearch = ({ origin, destination } = {}) =>
  isCityPlace(origin) && isCityPlace(destination);

export function removeHybridRecentSearches(recentSearchesLS) {
  const recentSearches = JSON.parse(localStorage.getItem(recentSearchesLS)) || [];
  const filteredRecentSearches = recentSearches.filter(search => !isHybridRecentSearch(search));

  if (filteredRecentSearches.length !== recentSearches.length) {
    localStorage.setItem(recentSearchesLS, JSON.stringify(filteredRecentSearches));
  }

  return filteredRecentSearches;
}

export function saveRecentSearches(origin, destination, maxRecentSearches, recentSearchesLS) {
  const recentSearches = getRecentSearches(maxRecentSearches, recentSearchesLS);
  const originExists = recentSearches.find(search => search.origin.id === origin.id);
  const destinationExists = recentSearches.find(search => search.destination.id === destination.id);
  if (originExists && destinationExists) return;
  if (recentSearches.length >= maxRecentSearches) recentSearches.pop();

  // Deleting extra props
  delete origin.preferred;
  delete destination.preferred;
  delete destination.isPopularDestination;

  recentSearches.unshift({
    origin: decamelizeKeys(origin),
    destination: decamelizeKeys(destination),
  });
  localStorage.setItem(recentSearchesLS, JSON.stringify(recentSearches));
}

/**
 * Reads every stored recent search, uncut. For display only: it never writes, so a caller can
 * hide entries without deleting them.
 */
export function readRecentSearches(recentSearchesLS) {
  return JSON.parse(localStorage.getItem(recentSearchesLS)) || [];
}

export function getRecentSearches(maxRecentSearches, recentSearchesLS) {
  return readRecentSearches(recentSearchesLS).splice(0, maxRecentSearches);
}
